// assets/fhl-auth.js
// Handles Create Account modal, Login modal, Orders modal, Account Details modal,
// and FHL GO account ID generation

document.addEventListener('DOMContentLoaded', () => {
  // ---------- BASE ELEMENTS ----------
  const createModal  = document.getElementById('createAccountModal');
  const loginModal   = document.getElementById('loginModal');
  const ordersModal  = document.getElementById('ordersModal');
  const accountModal = document.getElementById('accountDetailsModal');

  // If NONE of the modals exist, nothing to do
  if (!createModal && !loginModal && !ordersModal && !accountModal) return;

  // Match modal font to the hero/body font
  const fontSourceEl =
    document.getElementById('heroTitleTop') || document.body;

  const refFont = fontSourceEl
    ? window.getComputedStyle(fontSourceEl).fontFamily
    : null;

  function applyFontToModal(modal) {
    if (!modal || !refFont) return;
    modal.style.fontFamily = refFont;
    modal.querySelectorAll('*').forEach((el) => {
      el.style.fontFamily = refFont;
    });
  }

  applyFontToModal(createModal);
  applyFontToModal(loginModal);
  applyFontToModal(ordersModal);
  applyFontToModal(accountModal);

  // =========================================================
  // CREATE ACCOUNT MODAL
  // =========================================================
  const openCreateBtn  = document.getElementById('createAccountTrigger');
  const createCloseBtn = document.getElementById('createAccountClose');
  const cancelBtn      = document.getElementById('createAccountCancel');
  const createForm     = document.getElementById('createAccountForm');

  const firstInput   = document.getElementById('caFirstName');
  const lastInput    = document.getElementById('caLastName');
  const countryInput = document.getElementById('caCountry');
  const accountInput = document.getElementById('caAccountNumber');
  const passInput    = document.getElementById('caPassword');
  const passConfirm  = document.getElementById('caPasswordConfirm');
  const termsCheck   = document.getElementById('caTerms');

  function openCreateModal() {
    if (!createModal) return;
    createModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }

  function closeCreateModal() {
    if (!createModal) return;
    createModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }

  // Wire Create Account triggers
  if (openCreateBtn && createModal) {
    openCreateBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openCreateModal();
    });
  }

  if (createCloseBtn) {
    createCloseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeCreateModal();
    });
  }

  if (cancelBtn) {
    cancelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeCreateModal();
    });
  }

  if (createModal) {
    // Close on backdrop click
    createModal.addEventListener('click', (e) => {
      if (e.target === createModal) {
        closeCreateModal();
      }
    });
  }

  // =========================================================
  // LOGIN / RECOVER MODAL
  // =========================================================
  const loginCloseBtn  = document.getElementById('loginClose');
  const loginOpenBtns  = document.querySelectorAll('.open-login-modal');
  const loginPane      = document.getElementById('loginPane');
  const recoverPane    = document.getElementById('recoverPane');
  const forgotLink     = document.getElementById('forgotPasswordLink');
  const backToLoginBtn = document.getElementById('backToLogin');

  function openLoginModal() {
    if (!loginModal) return;
    loginModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }

  function closeLoginModal() {
    if (!loginModal) return;
    loginModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }

  function showLoginPane() {
    if (loginPane)   loginPane.classList.remove('is-hidden');
    if (recoverPane) recoverPane.classList.add('is-hidden');
  }

  function showRecoverPane() {
    if (loginPane)   loginPane.classList.add('is-hidden');
    if (recoverPane) recoverPane.classList.remove('is-hidden');
  }

  if (loginModal) {
    // Any button with .open-login-modal opens it (always start on login pane)
    loginOpenBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        showLoginPane();
        openLoginModal();
      });
    });

    if (loginCloseBtn) {
      loginCloseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        closeLoginModal();
      });
    }

    // Forgot password → show recover pane
    if (forgotLink) {
      forgotLink.addEventListener('click', (e) => {
        e.preventDefault();
        showRecoverPane();
      });
    }

    // Back to login → show login pane
    if (backToLoginBtn) {
      backToLoginBtn.addEventListener('click', (e) => {
        e.preventDefault();
        showLoginPane();
      });
    }

    // Close on backdrop click
    loginModal.addEventListener('click', (e) => {
      if (e.target === loginModal) {
        closeLoginModal();
      }
    });
  }

  // =========================================================
  // ORDERS MODAL
  // =========================================================
  const ordersTrigger  = document.getElementById('ordersTrigger');
  const ordersCloseBtn = document.getElementById('ordersClose');

  function openOrdersModal() {
    if (!ordersModal) return;
    ordersModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }

  function closeOrdersModal() {
    if (!ordersModal) return;
    ordersModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }

  if (ordersTrigger && ordersModal) {
    ordersTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      openOrdersModal();
    });
  }

  if (ordersCloseBtn) {
    ordersCloseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeOrdersModal();
    });
  }

  if (ordersModal) {
    // Close on backdrop click
    ordersModal.addEventListener('click', (e) => {
      if (e.target === ordersModal) {
        closeOrdersModal();
      }
    });
  }

  // =========================================================
  // ACCOUNT DETAILS MODAL
  // =========================================================
  const accountTrigger  = document.getElementById('accountDetailsTrigger');
  const accountCloseBtn = document.getElementById('accountDetailsClose');

  function openAccountModal() {
    if (!accountModal) return;
    accountModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }

  function closeAccountModal() {
    if (!accountModal) return;
    accountModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }

  if (accountTrigger && accountModal) {
    accountTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      openAccountModal();
    });
  }

  if (accountCloseBtn) {
    accountCloseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeAccountModal();
    });
  }

  if (accountModal) {
    // Close on backdrop click
    accountModal.addEventListener('click', (e) => {
      if (e.target === accountModal) {
        closeAccountModal();
      }
    });
  }

  // =========================================================
  // ESC KEY CLOSES WHICHEVER MODAL IS OPEN
  // =========================================================
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    if (createModal && createModal.getAttribute('aria-hidden') === 'false') {
      closeCreateModal();
    }
    if (loginModal && loginModal.getAttribute('aria-hidden') === 'false') {
      closeLoginModal();
    }
    if (ordersModal && ordersModal.getAttribute('aria-hidden') === 'false') {
      closeOrdersModal();
    }
    if (accountModal && accountModal.getAttribute('aria-hidden') === 'false') {
      closeAccountModal();
    }
  });

  // =========================================================
  // CREATE ACCOUNT: FHL GO ACCOUNT NUMBER GENERATION
  // =========================================================

  // If there is no create-account form on this page, we're done with the rest
  if (!createForm) return;

  // Country → prefix + numeric block
  const COUNTRY_BLOCKS = {
    'Peru': {
      prefix: 'PE',
      min: 1,
      max: 25000
    },
    'Costa Rica': {
      prefix: 'CR',
      min: 25001,
      max: 50000
    },
    'Venezuela': {
      prefix: 'VE',
      min: 50001,
      max: 75000
    },
    'United States': {
      prefix: 'US',
      min: 75001,
      max: 99999
    }
  };

  // Track IDs generated in this session so we don't repeat locally
  const usedIds = new Set();

  function getBlockConfig() {
    if (!countryInput || !countryInput.value) {
      return COUNTRY_BLOCKS['United States'];
    }
    const val = countryInput.value;
    return COUNTRY_BLOCKS[val] || COUNTRY_BLOCKS['United States'];
  }

  function generateAccountNumber() {
    const cfg   = getBlockConfig();
    const range = cfg.max - cfg.min + 1;

    // Simple safety net to avoid infinite loop in the extreme case
    let tries = 0;
    while (tries < 50) {
      const raw = cfg.min + Math.floor(Math.random() * range); // [min,max]
      const num = String(raw).padStart(5, '0');
      const id  = cfg.prefix + num; // e.g. PE01234

      if (!usedIds.has(id)) {
        usedIds.add(id);
        return id;
      }
      tries++;
    }

    // Fallback: if somehow we exhausted tries, just return something in range
    const fallbackRaw = cfg.min + Math.floor(Math.random() * range);
    const fallbackNum = String(fallbackRaw).padStart(5, '0');
    return cfg.prefix + fallbackNum;
  }

  function refreshAccountNumber() {
    if (!accountInput) return;
    accountInput.value = generateAccountNumber();
  }

  // Update ID when country changes (main driver)
  if (countryInput) {
    countryInput.addEventListener('change', refreshAccountNumber);
  }

  // Also refresh when first/last blur, so user sees something early
  if (firstInput) {
    firstInput.addEventListener('blur', refreshAccountNumber);
  }
  if (lastInput) {
    lastInput.addEventListener('blur', refreshAccountNumber);
  }

  // Front-end sanity checks for Create Account
  createForm.addEventListener('submit', (e) => {
    // Ensure we have an ID before submit
    if (accountInput && !accountInput.value) {
      refreshAccountNumber();
    }

    if (passInput && passConfirm && passInput.value !== passConfirm.value) {
      e.preventDefault();
      alert('Passwords do not match.');
      return;
    }

    if (accountInput && !accountInput.value) {
      e.preventDefault();
      alert('We couldn’t generate your FHL GO account number. Please pick your country and try again.');
      return;
    }

    if (termsCheck && !termsCheck.checked) {
      e.preventDefault();
      alert('You need to agree to the Terms of Service and Privacy Policy.');
      return;
    }

    // Let Shopify handle the POST to /account
  });
});
